<template>
  <table
    class="budget-table"
    v-if="budget.total"
  >
    <template v-for="(item, i) in budget.items">
      <tr
        v-if="!!item.commissionable && item.total"
        :key="'a_' + i"
      >
        <td>
          <span class="budget-table--span">{{ item.description }}</span>
        </td>
        <td>{{ budget.currency + item.total }}</td>
      </tr>
    </template>
    <tr>
      <td><strong>TOTAL</strong></td>
      <td>
        <span class="budget-table--totals">
          {{ budget.currency }} {{ budget.commissionable }}
        </span>
      </td>
    </tr>
    <tr>
      <td
        class="budget-table--division"
        colspan="2"
      />
    </tr>
    <template v-for="(item, i) in budget.items">
      <tr
        v-if="!item.commissionable && item.description"
        :key="'b_' + i"
      >
        <td>
          <span class="budget-table--span">{{ item.description }}</span>
        </td>
        <td>{{ item.total ? budget.currency + item.total : '- -' }}</td>
      </tr>
    </template>
    <tr class="budget-table--final">
      <td><span>PRECIO VIAJE</span></td>
      <td>
        <span>{{ budget.currency }} {{ budget.total }}</span>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  computed: {
    budget () {
      return this.$store.state.modify.budget
    }
  }
}
</script>
